module.exports = __webpack_public_path__ + "img/stena00.108c61e0.jpg";